import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=5adf6580&"
import script from "./TabView.vue?vue&type=script&lang=ts&"
export * from "./TabView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports